import React from "react";
import { Newnav } from "./Newnav";
import "./contact.css";
import ins from "../src/images/ins_white.png";
import fb from "../src/images/fb.png";

const ContactUs = ({ nav = true }) => {
  return (
    <div className="contact-page">
      {nav && <Newnav />}
      <div className="contact-hero">
        <div className="left">
          <h1 className="big-title">
            GET IN
            <br />
            TOUCH
          </h1>
        </div>
        <div className="right">
          <div className="contact-info">
            <h3>Email:</h3>
            <p className="contact-email">
              <a href="mailto:doubleknotcollective604@gmail.com">
                doubleknotcollective604@gmail.com
              </a>
            </p>

            <div className="socials">
              <a href="https://www.instagram.com/doubleknotcollective/">
                <img src={ins} alt="instagram" width={20} />
              </a>
              <a href="https://www.facebook.com/doubleknotcollective/">
                <img src={fb} alt="facebook" width={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ContactUs };
